import * as React from 'react';

import { Direction } from '~shared/utils/sort';
import { ResultsSortIndicator } from '~teacher/components/ResultsGrid/ResultsSortIndicator';

import { FocusIndicator } from '../FocusIndicator/FocusIndicator';

export interface Props {
  children: React.ReactNode;
  onClick: () => void;
  sortDirection?: Direction;
}

/**
 * A button to change and indicate how a table is sorted. Should be used within
 * a `th` element.
 *
 * **Remember**: Add `aria-sort` to the `th` element with the value of
 * `sortDirection` if it is being sorted, and remove the attribute otherwise.
 *
 * @todo Move `ResultsSortIndicator` into this component, use this component in
 *       Results Grid header.
 */
export function TableSortButton({ children, onClick, sortDirection }: Props) {
  return (
    <button
      className="group relative px-4 py-5 m-0 bg-transparent border-0 rounded-2 outline-none cursor-pointer"
      onClick={onClick}
      type="button"
    >
      <FocusIndicator notOffset isInset />
      <div className="flex items-center">
        <span className="text-xs font-700 leading-8 text-cyan-700 tracking-wider uppercase">
          {children}
        </span>
        {sortDirection ? (
          <div className="flex pl-1">
            <ResultsSortIndicator direction={sortDirection} />
          </div>
        ) : null}
      </div>
    </button>
  );
}
